/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './describeRepo.defs.js'
export * as $defs from './describeRepo.defs.js'
